(() => {
  if (window.mtWristCardsReady) return;
  window.mtWristCardsReady = true;
  const touchLayout = matchMedia('(hover: none), (pointer: coarse)');
  const init = root => {
    const cards = root.matches?.('[data-mt-wrist-card]') ? [root] : root.querySelectorAll?.('[data-mt-wrist-card]') || [];
    cards.forEach(card => {
      const link = card.querySelector('.mt-wrist-photo-link');
      const image = card.querySelector('.mt-wrist-card-image');
      if (!link || !image || link.dataset.ready) return;
      link.dataset.ready = 'true';
      let down = null, moved = false, pointerType = '';
      link.addEventListener('pointerdown', event => {
        down = { x: event.clientX, y: event.clientY };
        moved = false; pointerType = event.pointerType;
      }, { passive: true });
      link.addEventListener('pointermove', event => {
        if (down && Math.hypot(event.clientX - down.x, event.clientY - down.y) > 12) moved = true;
      }, { passive: true });
      link.addEventListener('pointercancel', () => { moved = true; down = null; }, { passive: true });
      image.addEventListener('error', () => {
        card.removeAttribute('data-wrist-active');
        card.removeAttribute('data-mt-wrist-card');
        image.remove();
      }, { once: true });
      link.addEventListener('click', event => {
        // Keyboard activation and modified clicks retain normal link navigation.
        if (event.detail === 0 || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        if (pointerType !== 'touch' && pointerType !== 'pen' && !touchLayout.matches) return;
        if (moved) { event.preventDefault(); event.stopPropagation(); return; }
        if (!card.hasAttribute('data-mt-wrist-card') || card.hasAttribute('data-wrist-active')) return;
        event.preventDefault(); event.stopPropagation();
        card.setAttribute('data-wrist-active', '');
      });
    });
  };
  init(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) init(node);
  }))).observe(document.body, { childList: true, subtree: true });
})();